import * as React from 'react';
import { RichTextArea } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachRichText } from '../../hooks/use-bloomreach-rich-text.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

/**
 * This variant of the Rich Text component is used on container (drag & drop) pages
 */ const CmsRichText = ({ page , content , meta , template  })=>{
    var ref;
    const richText = useBloomreachRichText((ref = content.content) === null || ref === void 0 ? void 0 : ref.value);
    if (!richText) {
        return null;
    }
    switch(template){
        case 'default':
            return /*#__PURE__*/ React.createElement(RichTextArea, {
                content: richText,
                textColor: meta.textColor,
                backgroundColor: meta.backgroundColor,
                "data-t": "rich-text"
            });
        // Full-width template to display content in full container width.
        case 'full-width':
            return /*#__PURE__*/ React.createElement(RichTextArea, {
                content: richText,
                textColor: meta.textColor,
                backgroundColor: meta.backgroundColor,
                fullWidth: true,
                "data-t": "rich-text"
            });
        // Modal template is only added to be able to retrieve the content from the pageModel.
        case 'modal':
            return page.isPreview() ? /*#__PURE__*/ React.createElement(RichTextArea, {
                content: richText
            }) : null;
        default:
            return /*#__PURE__*/ React.createElement(Heading, {
                variant: "subheading1"
            }, "RichText component of type ", template, " not defined in RichTextCollection");
    }
};
var RichText = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsRichText);

export { CmsRichText, RichText as default };
//# sourceMappingURL=RichText.js.map
